import _ from "lodash";

const {REACT_APP_API_URL} = process.env;
export const getServerUrl = (url) => (REACT_APP_API_URL + url);
export const getImageUrl = (image) => _.isNil(_.get(image, "url", null)) ? null : getServerUrl(image.url)
export const get = (object, path, defaultValue) => _.get(object, path, defaultValue);